import { render, staticRenderFns } from "./ModalNovoModeloFoto.vue?vue&type=template&id=5d0ded80"
import script from "./ModalNovoModeloFoto.vue?vue&type=script&lang=js"
export * from "./ModalNovoModeloFoto.vue?vue&type=script&lang=js"
import style0 from "./ModalNovoModeloFoto.vue?vue&type=style&index=0&id=5d0ded80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports